export type EnterpriseWorkspaceCheckIn = {
  id: string;
  organizationId: string;
  relationshipDomain: 'leadership' | 'friendship' | 'family' | 'romantic';
  entityLabel: string | null;
  rtiScore: number;
  emotionalAverage: number;
  triggers: string[];
  note: string | null;
  occurredAt: string;
};

const STORAGE_KEY = 'tension_enterprise_workspace_checkins_v1';

function safeParse(raw: string | null): EnterpriseWorkspaceCheckIn[] {
  if (!raw) return [];
  try {
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((row): row is EnterpriseWorkspaceCheckIn => {
      if (!row || typeof row !== 'object') return false;
      const r = row as Record<string, unknown>;
      return (
        typeof r.id === 'string' &&
        typeof r.organizationId === 'string' &&
        typeof r.relationshipDomain === 'string' &&
        typeof r.rtiScore === 'number' &&
        typeof r.emotionalAverage === 'number' &&
        typeof r.occurredAt === 'string'
      );
    });
  } catch {
    return [];
  }
}

export function listEnterpriseWorkspaceCheckIns(orgId: string): EnterpriseWorkspaceCheckIn[] {
  if (typeof window === 'undefined') return [];
  const all = safeParse(localStorage.getItem(STORAGE_KEY));
  return all.filter((entry) => entry.organizationId === orgId).sort((a, b) => b.occurredAt.localeCompare(a.occurredAt));
}

export function appendEnterpriseWorkspaceCheckIn(entry: EnterpriseWorkspaceCheckIn): void {
  if (typeof window === 'undefined') return;
  const all = safeParse(localStorage.getItem(STORAGE_KEY));
  all.push(entry);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
}

